import React, { Component } from "react";
import _ from "lodash";
import { basicColors, retroColors, electricColors } from "../../../../style/basic/basicColors";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import { treeToArray, treeToPropertiesObject } from "../../../../utils/treeData";
import { languageService } from "../../../../Language/language.service";
function compareByFirstLetter(a, b) {
  const firstLetterA = a.title.trim().toLowerCase();
  const firstLetterB = b.title.trim().toLowerCase();

  if (firstLetterA < firstLetterB) {
    return -1;
  }
  if (firstLetterA > firstLetterB) {
    return 1;
  }
  return 0;
}

class AssetTestSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lists: [],
      listsIndex: 0,
      selectedItemsInList: [],
      selectedAsset: null,
      hideListView: true,
      searchValue: "",
      searchList: [],
      filterSearchList: [],
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleListItemClick = this.handleListItemClick.bind(this);
  }

  componentDidMount() {
    if (this.props.listItems && this.props.listItems.length > 0) {
      this.setState({
        lists: [this.props.listItems],
        listIndex: 0,
        selectedItemsInList: [],
      
      });
    }

    if (this.props.searchList && this.props.searchList.length > 0) {
      this.setState({
        searchList: this.props.searchList,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listItems !== this.props.listItems && this.props.listItems) {
      this.setState({
        lists: [this.props.listItems],
        listIndex: 0,
      });
    }

    if (prevProps.searchList !== this.props.searchList && this.props.searchList) {
      this.setState({
        searchList: this.props.searchList,
      });
    }
  }

  handleSearch(value) {
    if (value.trim() === "") {
      this.setState({ hideListView: true, filterSearchList: [] });
    } else {
      let filterArray = this.state.searchList.filter((e) => e.title.toLowerCase().includes(value.toLowerCase()));

      let groupedFilterArray = _.groupBy(filterArray, "location");

      const sortedKeys = Object.keys(groupedFilterArray).sort();

      const sortedObject = {};

      sortedKeys.forEach((key) => {
        sortedObject[key] = groupedFilterArray[key].sort(compareByFirstLetter);
      });

      this.setState({ hideListView: false, filterSearchList: [sortedObject] });
    }
  }

  handleSearchClick(item) {
    this.setState({ selectedAsset: item });
  }
  handleListItemClick(listItem, listIndex) {
    let listToUp = [...this.state.lists];
    let selectedItemsInList = [...this.state.selectedItemsInList];
    let selectedAsset = { ...this.state.selectedAsset };
    this.checkIfPrevListClicked(listToUp, listIndex);
    this.checkIfPrevListClicked(selectedItemsInList, listIndex);
    listToUp.push(listItem.children);
    let newIndex = listToUp.length - 1;
    if (listIndex > 0) selectedAsset = listItem;
    else selectedAsset = null;
    selectedItemsInList[listIndex] = listItem.id;
    this.setState({ lists: listToUp, listIndex: newIndex, selectedItemsInList, selectedAsset });
  }

  checkIfPrevListClicked(listToUp, listIndex) {
    if (listIndex < this.state.listIndex) {
      _.remove(listToUp, (l, i) => {
        return i > listIndex;
      });
    }
  }

  render() {
    let listsRenders = this.state.lists.map((list, index) => {
      return (
        <ListRenderer
          listIndex={index}
          key={list.id}
          list={list.sort(compareByFirstLetter)}
          handleListItemClick={this.handleListItemClick}
          selectedId={this.state.selectedItemsInList[index]}
        />
      );
    });
    let filterSearchListRender = this.state.filterSearchList.map((list, index) => {
      // return <ListRenderer listIndex={index} key={list.id} list={list} handleListItemClick={this.handleSearchClick} />;
      return <FilterListRenderer listIndex={index} key={list.id} list={list} handleListItemClick={this.handleSearchClick} />;
    });
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SelectedAsset
            selectedAsset={this.state.selectedAsset}
            onSelectionItem={(e) => {
              this.props.onSelectItem(this.state.selectedAsset);
            }}
          />
          <input
            type="text"
            onChange={(e) => this.handleSearch(e.target.value)}
            placeholder={`${languageService("Search")}...`}
            style={{ ...rowItemStyle, marginLeft: "25px", marginBottom: "25px", cursor: "default" }}
          />
        </div>

        {this.state.filterSearchList.length === 0 ? (
          <div style={allListContainerStyle}>{listsRenders}</div>
        ) : (
          <div style={allListContainerStyle}>{filterSearchListRender}</div>
        )}
      </div>
    );
  }
}

export default AssetTestSelector;

const ListRenderer = (props) => {
  let ListToShow =
    props.list &&
    props.list.map((item) => {
      return (
        <RowItem
          title={item.title}
          handleListItemClick={(e) => {
            props.handleListItemClick(item, props.listIndex);
          }}
          selected={item.id == props.selectedId}
        />
      );
    });
  return (
    <div style={listContainerStyle} className="scrollbar">
      {ListToShow}{" "}
    </div>
  );
};

const FilterListRenderer = (props) => {
  let ListToShow =
    props.list &&
    Object.keys(props.list).map((key) => {
      return (
        <React.Fragment>
          {props.list[key].map((obj, index) => (
            <RowItem
              title={obj.title}
              handleListItemClick={(e) => {
                props.handleListItemClick(obj);
              }}
              location={index === 0 ? key : null}
              selected={obj.id == props.selectedId}
            />
          ))}
        </React.Fragment>
      );
    });

  return (
    <div style={listContainerStyle} className="scrollbar">
      {ListToShow}{" "}
    </div>
  );
};

const RowItem = (props) => {
  let adjustStyler = props.selected ? { background: "var(--first)" } : {};
  return (
    <div style={{ ...rowItemStyle, ...adjustStyler }} onClick={props.handleListItemClick}>
      {props.location && <p style={{ marginBottom: "0px", fontSize: "14px", fontWeight: "bold" }}>{props.location}</p>}
      {props.title}
    </div>
  );
};

const SelectedAsset = (props) => {
  return (
    <div>
      <div style={selectedAssetStyle}> {props.selectedAsset ? props.selectedAsset.title : languageService("Please Select Asset")}</div>
      <div style={{ cursor: "pointer", display: "inline-block" }}>
        <MyButton disabled={!props.selectedAsset} onClick={props.onSelectionItem}>
          {languageService("Load")}
        </MyButton>
      </div>
    </div>
  );
};

const rowItemStyle = {
  background: "var(--fifth)",
  fontSize: "12px",
  color: "var(--second)",
  padding: "5px",
  marginRight: "10px",
  minWidth: "350px",
  cursor: "pointer",
};
const listContainerStyle = { display: "inline-block", maxHeight: "70vh", overflow: "auto" };
const allListContainerStyle = { display: "inline-flex" };
const selectedAssetStyle = {
  display: "inline-block",
  background: "var(--fifth)",
  fontSize: "12px",
  color: "var(--second)",
  padding: "5px 10px",
  marginRight: "30px",
  marginBottom: "15px",
  minWidth: "350px",
  border: "1px solid ",
};



// WEBPACK FOOTER //
// ./src/components/JourneyPlan/AssetInspections/AssetTestSelector/AssetTestSelector.jsx